import React, {forwardRef} from 'react';
import {useNoteContext} from './useNote';
import {NoteActionsView} from './Note.styles';

export type NoteActionsProps = {
  children: React.ReactNode;
};

/**
 * # NoteActions
 *
 * A wrapper that horizontally aligns controls within a Note.
 *
 * ## Usage
 *
 * ```jsx
 * import {Note, NoteBody, NoteActions, NoteButton} from '@packages/systems/spring';
 *
 * const Example = () => {
 *   return (
 *     <Note>
 *       <NoteBody>This is a note with controls.</NoteBody>
 *       <NoteActions>
 *         <NoteButton>Primary action</NoteButton>
 *         <NoteButton>Secondary action</NoteButton>
 *       </NoteActions>
 *     </Note>
 *   );
 * };
 * ```
 */
export const NoteActions = forwardRef<HTMLDivElement, NoteActionsProps>(
  ({children}: NoteActionsProps, ref) => {
    const {isInline} = useNoteContext();

    return (
      <NoteActionsView isInline={isInline} ref={ref}>
        {children}
      </NoteActionsView>
    );
  }
);

NoteActions.displayName = 'NoteActions';
NoteActions.toString = NoteActionsView.toString;

export default NoteActions;
